import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const Footer = () => {
  const { t, i18n } = useTranslation();

  const footerLinks = {
    en: [
      { title: 'Quick Links', links: [
        { name: 'Home', path: '/' },
        { name: 'About', path: '/about' },
        { name: 'Contact', path: '/contact' },
        { name: 'FAQ', path: '/faq' }
      ]},
      { title: 'Resources', links: [
        { name: 'Safety Guidelines', path: '/safety-guidelines' },
        { name: 'Training Materials', path: '/training' },
        { name: 'Documentation', path: '/docs' },
        { name: 'Compliance', path: '/compliance' }
      ]},
      { title: 'Legal', links: [
        { name: 'Privacy Policy', path: '/privacy-policy' },
        { name: 'Terms of Service', path: '/terms' },
        { name: 'Cookie Policy', path: '/cookie-policy' }
      ]}
    ],
    th: [
      { title: 'ลิงก์ด่วน', links: [
        { name: 'หน้าแรก', path: '/' },
        { name: 'เกี่ยวกับ', path: '/about' },
        { name: 'ติดต่อ', path: '/contact' },
        { name: 'คำถามที่พบบ่อย', path: '/faq' }
      ]},
      { title: 'ทรัพยากร', links: [
        { name: 'แนวทางความปลอดภัย', path: '#' },
        { name: 'วัสดุการฝึกอบรม', path: '#' },
        { name: 'เอกสาร', path: '#' },
        { name: 'การปฏิบัติตามข้อกำหนด', path: '#' }
      ]},
      { title: 'กฎหมาย', links: [
        { name: 'นโยบายความเป็นส่วนตัว', path: '#' },
        { name: 'ข้อกำหนดการใช้บริการ', path: '#' },
        { name: 'นโยบายคุกกี้', path: '#' }
      ]}
    ]
  };

  const links = footerLinks[i18n.language] || footerLinks.en;

  return (
    <footer className="bg-hemp-green-800 text-white">
      <div className="max-w-7xl mx-auto py-12 px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="col-span-1 md:col-span-1">
            <h3 className="text-lg font-bold mb-4">
              {t('footer.company')}
            </h3>
            <p className="text-hemp-green-100 mb-4">
              {t('footer.description')}
            </p>
            <div className="flex space-x-4">
              <a href="#" className="text-hemp-green-200 hover:text-white transition-colors">
                <span className="sr-only">Facebook</span>
                <svg className="h-6 w-6" fill="currentColor" viewBox="0 0 24 24">
                  <path fillRule="evenodd" d="M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.878v-6.987h-2.54V12h2.54V9.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V12h2.773l-.443 2.89h-2.33v6.988C18.343 21.128 22 16.991 22 12z" clipRule="evenodd" />
                </svg>
              </a>
              <a href="#" className="text-hemp-green-200 hover:text-white transition-colors">
                <span className="sr-only">Twitter</span>
                <svg className="h-6 w-6" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M8.29 20.251c7.547 0 11.675-6.253 11.675-11.675 0-.178 0-.355-.012-.53A8.348 8.348 0 0022 5.92a8.19 8.19 0 01-2.357.646 4.118 4.118 0 001.804-2.27 8.224 8.224 0 01-2.605.996 4.107 4.107 0 00-6.993 3.743 11.65 11.65 0 01-8.457-4.287 4.106 4.106 0 001.27 5.477A4.072 4.072 0 012.8 9.713v.052a4.105 4.105 0 003.292 4.022 4.095 4.095 0 01-1.853.07 4.108 4.108 0 003.834 2.85A8.233 8.233 0 012 18.407a11.616 11.616 0 006.29 1.84" />
                </svg>
              </a>
            </div>
          </div>

          {/* Footer Links */}
          {links.map((section, index) => (
            <div key={index} className="col-span-1">
              <h3 className="text-lg font-bold mb-4">
                {section.title}
              </h3>
              <ul className="space-y-2">
                {section.links.map((link, linkIndex) => (
                  <li key={linkIndex}>
                    <Link 
                      to={link.path} 
                      className="text-hemp-green-200 hover:text-white transition-colors"
                    >
                      {link.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Copyright */}
        <div className="mt-12 pt-8 border-t border-hemp-green-700 text-center">
          <p className="text-hemp-green-200">
            &copy; {new Date().getFullYear()} {t('footer.copyright')}. {t('footer.rights')}.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
